import renderPatientView from './patientView.js';
import getOffsetTop from './getOffsetTop.js';
import { getAppsforCurrentDoc, setDocById, getUniqueAppTimes } from './doctorMethods.js';

module.exports = {
  events,
  eventClick,
  viewRender,
  createCalendarEvents,
}

//Fetches appointment data from web server when calendar loads or changes view
//Formats data for use in calendar rendering
function events(start, end, timezone, callback) {
  if (window.PB.appointments && !window.PB.shouldFetch) {
    callback(getAppsforCurrentDoc());
  } else {
    console.log('fetching apt data');
    const business_id = $('#business-data').attr('data-business-id');
    const location_id = $('#business-data').attr('data-location-id');
    const doctor_id = $('#business-data').attr('data-doctor-id');

    const data = {
      start: start.format('YYYY-MM-DD'),
      end: end.format('YYYY-MM-DD'),
    };

    if (doctor_id !== '') {
      data.doctor_id = doctor_id;
    }

    $.ajax({
      url: `/appointments/business_id/${business_id}/location_id/${location_id}`,
      dataType: 'json',
      data: data,
      success: (data) => {
        window.PB.fetchedData = JSON.parse(data);
        const aptsArr = createAppointments(data);
        window.PB.appointments = aptsArr;
        callback(getAppsforCurrentDoc());
      },
      error: (jqXHR, status, error) => {
        console.log('error fetching apt data');
        console.log('status:', status);
        console.log('error:', error);
      }
    })
  }

}

function createAppointments(eventData) {
  const parsed = JSON.parse(eventData);
  const aptsByDoctors = parsed.available_times;
  const aptsArr = formatDoctorApps(aptsByDoctors);

  return createCalendarEvents(aptsArr);
}

//events -- Called when web server returns json event data
function createCalendarEvents(aptsArr) {
  const sortedAptsObj = sortAptsByDay(aptsArr);
  const calendarEventsArr = formatRenderedEvents(sortedAptsObj);
  return calendarEventsArr;
}

function formatDoctorApps(aptsByDoctors) {
  let mappedArray = [];
  for (let i = 0; i < aptsByDoctors.length; i++) {
    aptsByDoctors[i].mappedApps = aptsByDoctors[i].time_intervals.map(int => ({...int, doctor_id: aptsByDoctors[i].doctor_id }));
    mappedArray = mappedArray.concat(aptsByDoctors[i].mappedApps);
  }
  return mappedArray;
}

//events -- Creates an object which categorizes appointments by day
function sortAptsByDay(aptsArr) {
  const sortedApts = {};

  aptsArr.forEach(aptObj => {
    const day = moment.parseZone(aptObj.start_time).format('YYYY-MM-DD');
    if (sortedApts[day]) sortedApts[day].push(aptObj);
    else sortedApts[day] = [aptObj];
  })

  return sortedApts;
}

//events -- Formats events so calendar can interpret them
function formatRenderedEvents(sortedObj) {
  const renderedEvents = [];
  for (let day in sortedObj) {
    const len = getUniqueAppTimes(sortedObj[day]).length;
    const title = (len > 9 ? '9+' : len.toString());
    renderedEvents.push({
      title: title,
      allDay: true,
      start: moment.parseZone(sortedObj[day][0].start_time),

      aptsArr: sortedObj[day],
    })
  }
  return renderedEvents;
}



//Called when an event is clicked ********************************************
function eventClick(event, jsEvent, view) {
  //Delete Existing Patient View (if one exists) to prevent duplicates
  $('#patient-info-row').remove();

  $('.selected-button').removeClass('selected-button');
  $(this).addClass('selected-button');

  //Render time section if not rendered already
  const $timesContainer = $('#times-container');
  if ($timesContainer.has('#times-wrapper').length === 0) {
    const $timesWrapper = $(document.createElement('div'))
      .attr('id', 'times-wrapper')
      .addClass('col-12');

    const $timesTitle = $(document.createElement('h2'))
      .attr('id', 'times-title').addClass('pb-subtitle col-12');

    const $timesList = $(document.createElement('div'))
      .attr('id', 'times-list')
      .addClass('row no-gutters');


    $timesWrapper.append($timesTitle, $timesList);
    $timesContainer.append($timesWrapper);
  };

  const $timesTitle = $('#times-title');
  const $timesList = $('#times-list');
  const renderDate = moment.parseZone(event.aptsArr[0].start_time).format('dddd, MMMM Do YYYY');
  $timesTitle.html(renderDate);

  if ($timesList.has('.time-button').length !== 0) {
    $timesList.empty();
    $timesList.scrollTop(0);
  }

  // append appointments
  event.aptsArr.forEach((apt, idx) => {

    $timesList.append($aptButton(apt));
  })

  //Scroll to List of Appointment Times
  if (window.innerWidth < 576) {
    setTimeout(function() {
      const target = getOffsetTop(document.querySelector('#times-wrapper'));
      $('#content').animate({
        scrollTop: target
      }, 600);
    }, 100);
  } else {
    $('html, body').animate({
      scrollTop: $('#times-wrapper').offset().top
    }, 600);
  }

}

function $aptButton(apt) {
  const renderedTime = moment.parseZone(apt.start_time).format('h:mm a');
  const $btnContainer = $(document.createElement('div')).addClass('col-6 col-sm-4 pb-btn-container');
  const $button = $(document.createElement('button'))
    .addClass('purple-button sec-button time-button ')
    .html(renderedTime)
    .click(() => {
      $('.time-button.selected-button').removeClass('selected-button');
      $button.addClass('selected-button');
      setDocById(apt.doctor_id);
      renderPatientView(apt);
    });
  $btnContainer.append($button);
  return $btnContainer;
}


//Called when a new calendar view is rendered
function viewRender(view, element) {
  $('#times-wrapper').remove();
  $('#patient-info-row').remove();

  //Disable navigating to view past months
  const today = moment();
  if (today > view.start && today < view.end) {
    $(".fc-prev-button").prop('disabled', true);
    $(".fc-prev-button").addClass('fc-state-disabled');
  } else {
    $(".fc-prev-button").removeClass('fc-state-disabled');
    $(".fc-prev-button").prop('disabled', false);
  }
}




// WEBPACK FOOTER //
// ./public/src/calMethods.js